import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  test,
  testsuccessMessage,
  totalPages,
  totalRecords,
  testError,
  testActivityInProcess,
} from "redux-store/lab-tests/tests.selecter";
import {
  getsubmittedTests,
  getnotsubmittedTests,
  petTestsClean,
  getAllHospitalTests,
} from "redux-store/lab-tests/tests.slice";
import { AppDispatch } from "redux-store/store";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import Loader from "components/loader/Loader";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { singleUser, user } from "redux-store/user/user.selectors";
import LabResultMobile from "components/dashboard/lab-result/LabResultMobile";
import HospitalTableRow from "./HospitalTableRow";

const HospitalTable = () => {
  let tests = useSelector(test);
  const dispatch = useDispatch<AppDispatch>();
  const loading = useSelector(testActivityInProcess);
  const testsUpdated = useSelector(testsuccessMessage);
  const errorMessage = useSelector(testError);
  const loggedInUser = useSelector(singleUser);
  const loggedUser = useSelector(user);
  let pages = useSelector(totalPages);
  var records = useSelector(totalRecords);
  const [activePage, setActivePage] = useState(1);
  const [pageValue, setPageValue] = useState({
    start: 1,
    second: 2,
    end: 3,
  });
  const [activeFilter, setActiveFilter] = useState({
    submit: true,
    notSubmit: false,
    all: true,
  });
  const [downOpenForPet, setDownForPet] = useState(false);
  const [downOpenForUser, setDownForUser] = useState(false);

  const incrementPageHandler = () => {
    setPageValue({
      ...pageValue,
      start: pageValue.start + 1,
      second: pageValue.second + 1,
      end: pageValue.end + 1,
    });
  };
  const decrementPageHandler = () => {
    setPageValue({
      ...pageValue,
      start: pageValue.start - 1,
      second: pageValue.second - 1,
      end: pageValue.end - 1,
    });
  };

  const onPageClickHandler = (pageNumber: any) => {
    dispatch(petTestsClean());
    setActivePage(pageNumber);
    if (activeFilter.submit) {
      dispatch(getsubmittedTests(pageNumber));
    } else if (activeFilter.notSubmit) {
      dispatch(getnotsubmittedTests(pageNumber));
    } else {
      dispatch(getAllHospitalTests(pageNumber));
    }
  };

  useEffect(() => {
    dispatch(getAllHospitalTests(1));
  }, []);

  useEffect(() => {
    if (testsUpdated === "Result submitted successfully") {
      if (activeFilter.notSubmit) {
        dispatch(getnotsubmittedTests(activePage));
      } else if (activeFilter.all) {
        dispatch(getAllHospitalTests(activePage));
      }
    }
  }, [testsUpdated]);

  useEffect(() => {
    if (errorMessage.message === "Result not found") {
      dispatch(petTestsClean());
    }
  }, [errorMessage]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1024);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isMobile]);

  const ascPetSortHandler = () => {
    const sortedTests =
      tests &&
      [...tests].sort((a: any, b: any) =>
        a.petId?.petName.localeCompare(b?.petId?.petName)
      );
    setDownForPet(true);
  };

  const descPetSortHandler = () => {
    const sortedTests =
      tests &&
      [...tests].sort((a: any, b: any) =>
        b.petId?.petName.localeCompare(a?.petId?.petName)
      );
    setDownForPet(false);
  };

  const ascUserSortHandler = () => {
    const sortedTests =
      tests &&
      [...tests].sort((a: any, b: any) =>
        a.userId.fullName.localeCompare(b.userId.fullName)
      );
    setDownForUser(true);
  };

  const descUserSortHandler = () => {
    const sortedTests =
      tests &&
      [...tests].sort((a: any, b: any) =>
        b.userId.fullName.localeCompare(a.userId.fullName)
      );
    setDownForUser(false);
  };

  const userhospitalName = String(loggedUser?.hospitalName).toLowerCase(); // user hospital Name

  // user Hospital Name Convert into string Array
  const userhospitalNamesArray = userhospitalName
    .split(",")
    .map((hospitalName) => hospitalName.trim().toLowerCase());

  // Filter same hospital Name Tests
  const filteredTests =
    tests?.filter(
      (item: any) =>
        item.submit === true &&
        item?.kitId?.careTeams?.some((i: any) =>
          userhospitalNamesArray.includes(String(i?.hospitalName).toLowerCase())
        )
    ) ?? [];
  // Render all Filters Tests
  const renderedTests = tests?.map((item: any, index: any) => (
    <HospitalTableRow result={item} key={index} />
  ));
  // Mobile Renderd Tests
  const MobilerenderedTests = tests?.map((item: any, index: any) => (
    <LabResultMobile result={item} key={index} />
  ));

  var records = tests?.length as number;

  return (
    <>
      {!loggedInUser?.isAdmin ? (
        <>
          {isMobile ? (
            <>
              {tests && tests.length !== 0 ? (
                <>
                  {/* renderd Filterd Tests on Mobile */}
                  {MobilerenderedTests}
                  <div className="tw-w-full tw-m-auto tw-flex tw-flex-col md:tw-flex-row tw-gap-[1rem] tw-items-center md:tw-justify-between sm:tw-justify-center tw-px-[10%] tw-mt-[2rem]">
                    <div className="">
                      <p className="tw-text-base tw-text-tabelHeadingColor tw-font-fontPara tw-font-medium">
                        Showing{" "}
                        {filteredTests && filteredTests.length > 0
                          ? Math.min(records, 20 * activePage)
                          : ""}{" "}
                        of {records}
                      </p>
                    </div>
                    <div className="flex flex-row gap-[0.5rem] tw-items-center">
                      <button
                        onClick={decrementPageHandler}
                        disabled={pageValue.start <= 1 ? true : false}
                        className={
                          pageValue.start <= 1
                            ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem] md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-1"
                            : "tw-px-[0.5rem] md:tw-px-[1.05rem] tw-py-[0.25rem] md:tw-py-[0.5rem] tw-text-sm md:tw-text-md tw-rounded-md tw-text-white tw-font-fontHeading tw-font-bold tw-bg-reddishOrange tw-mr-1"
                        }
                      >
                        <KeyboardDoubleArrowLeftIcon />
                      </button>
                      <button
                        disabled={pageValue.start > pages ? true : false}
                        className={
                          pageValue.start === activePage
                            ? "tw-bg-reddishOrange tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-white tw-border-[1px] tw-rounded-md tw-mr-2"
                            : pageValue.start > pages
                              ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-2"
                              : "tw-bg-white tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-black tw-border-[1px] tw-rounded-md tw-mr-2 hover:tw-bg-reddishOrange hover:tw-text-white"
                        }
                        onClick={() => onPageClickHandler(pageValue.start)}
                      >
                        {pageValue.start}
                      </button>
                      <button
                        disabled={pageValue.second > pages ? true : false}
                        className={
                          pageValue.second === activePage
                            ? "tw-bg-reddishOrange tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-white tw-border-[1px] tw-rounded-md tw-mr-2"
                            : pageValue.second > pages
                              ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-2"
                              : "tw-bg-white tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-black tw-border-[1px] tw-rounded-md tw-mr-2 hover:tw-bg-reddishOrange hover:tw-text-white"
                        }
                        onClick={() => onPageClickHandler(pageValue.second)}
                      >
                        {pageValue.second}
                      </button>
                      <button
                        disabled={pageValue.end > pages ? true : false}
                        className={
                          pageValue.end === activePage
                            ? "tw-bg-reddishOrange tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-white tw-border-[1px] tw-rounded-md tw-mr-1"
                            : pageValue.end > pages
                              ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-1"
                              : "tw-bg-white tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-black tw-border-[1px] tw-rounded-md hover:tw-bg-reddishOrange hover:tw-text-white tw-mr-1"
                        }
                        onClick={() => onPageClickHandler(pageValue.end)}
                      >
                        {pageValue.end}
                      </button>
                      <button
                        onClick={incrementPageHandler}
                        disabled={pageValue.end >= pages ? true : false}
                        className={
                          pageValue.end >= pages
                            ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem] md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-1"
                            : "tw-px-[0.5rem] md:tw-px-[1.05rem] tw-py-[0.25rem] md:tw-py-[0.5rem] tw-text-sm md:tw-text-md tw-rounded-md tw-text-white tw-font-fontHeading tw-font-bold tw-bg-reddishOrange tw-mr-1"
                        }
                      >
                        <KeyboardDoubleArrowRightIcon />
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              {loading && <Loader />}
              {!loading && tests?.length === 0 && "No Result Found"}
            </>
          ) : (
            <>
              <div className="tw-w-[90%] tw-relative tw-mx-auto tw-bg-[#FFFFFF] tw-shadow-3xl tw-rounded-xl  tw-py-7">
                <div className="tw-w-[90%] tw-mx-auto tw-flex tw-flex-col ">
                  {/* 1st item */}
                  <div className="tw-flex tw-items-center tw-justify-between tw-mb-5">
                    <div className="tw-flex-1 tw-text-xl tw-text-[#29223E] tw-font-bold tw-flex tw-items-center">
                      Customer Name
                      {downOpenForUser ? (
                        <ExpandMoreIcon
                          onClick={descUserSortHandler}
                          className={`${downOpenForUser ? "tw-hidden" : ""}`}
                        />
                      ) : (
                        <ExpandLessIcon
                          onClick={ascUserSortHandler}
                          className={`${downOpenForUser ? "" : "tw-hidden"}`}
                        />
                      )}
                    </div>
                    <div className="tw-flex-1 tw-text-xl tw-text-[#29223E] tw-font-bold tw-flex tw-gap-2 tw-items-center">
                      Pet Name
                      {downOpenForPet ? (
                        <ExpandMoreIcon
                          onClick={descPetSortHandler}
                          className={`${downOpenForPet ? "tw-hidden" : ""}`}
                        />
                      ) : (
                        <ExpandLessIcon
                          onClick={ascPetSortHandler}
                          className={`${downOpenForPet ? "" : "tw-hidden"}`}
                        />
                      )}
                    </div>
                    <div className="tw-flex-1 tw-text-xl tw-text-[#29223E] tw-font-bold">
                      Risk Level
                    </div>
                    <div className="tw-flex-1 tw-text-xl tw-text-[#29223E] tw-font-bold">
                      Risk Value
                    </div>
                    <div className="tw-flex-1 tw-text-xl tw-text-[#29223E] tw-font-bold">
                      Hospital Name
                    </div>
                    <div className="tw-flex-1 tw-text-xl tw-text-[#29223E] tw-font-bold"></div>
                  </div>
                  {/* 2nd item */}

                  {tests && tests.length !== 0 ? (
                    <>
                      {/* call Filterd Tests */}
                      {renderedTests}
                      <div className="tw-w-full md:tw-w-full tw-m-auto tw-flex tw-flex-col md:tw-flex-row tw-gap-[1rem] tw-items-center md:tw-justify-between sm:tw-justify-center tw-px-[3%] tw-mt-[2rem]">
                        <div className="">
                          <p className="tw-text-base tw-text-tabelHeadingColor tw-font-fontPara tw-font-medium">
                            {` Showing ${filteredTests && filteredTests.length > 0
                                ? Math.min(records, 20 * activePage)
                                : ""
                              } of ${records}`}
                          </p>
                        </div>
                        <div className="flex flex-row gap-[0.5rem] tw-items-center">
                          <button
                            onClick={decrementPageHandler}
                            disabled={pageValue.start <= 1 ? true : false}
                            className={
                              pageValue.start <= 1
                                ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem] md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-1"
                                : "tw-px-[0.5rem] md:tw-px-[1.05rem] tw-py-[0.25rem] md:tw-py-[0.5rem] tw-text-sm md:tw-text-md tw-rounded-md tw-text-white tw-font-fontHeading tw-font-bold tw-bg-reddishOrange tw-mr-1"
                            }
                          >
                            <KeyboardDoubleArrowLeftIcon />
                          </button>
                          <button
                            disabled={pageValue.start > pages ? true : false}
                            className={
                              pageValue.start === activePage
                                ? "tw-bg-reddishOrange tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-white tw-border-[1px] tw-rounded-md tw-mr-2"
                                : pageValue.start > pages
                                  ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-2"
                                  : "tw-bg-white tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-black tw-border-[1px] tw-rounded-md tw-mr-2 hover:tw-bg-reddishOrange hover:tw-text-white"
                            }
                            onClick={() => onPageClickHandler(pageValue.start)}
                          >
                            {pageValue.start}
                          </button>
                          <button
                            disabled={pageValue.second > pages ? true : false}
                            className={
                              pageValue.second === activePage
                                ? "tw-bg-reddishOrange tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-white tw-border-[1px] tw-rounded-md tw-mr-2"
                                : pageValue.second > pages
                                  ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-2"
                                  : "tw-bg-white tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-black tw-border-[1px] tw-rounded-md tw-mr-2 hover:tw-bg-reddishOrange hover:tw-text-white"
                            }
                            onClick={() => onPageClickHandler(pageValue.second)}
                          >
                            {pageValue.second}
                          </button>
                          <button
                            disabled={pageValue.end > pages ? true : false}
                            className={
                              pageValue.end === activePage
                                ? "tw-bg-reddishOrange tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-white tw-border-[1px] tw-rounded-md tw-mr-1"
                                : pageValue.end > pages
                                  ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-1"
                                  : "tw-bg-white tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-black tw-border-[1px] tw-rounded-md hover:tw-bg-reddishOrange hover:tw-text-white tw-mr-1"
                            }
                            onClick={() => onPageClickHandler(pageValue.end)}
                          >
                            {pageValue.end}
                          </button>
                          <button
                            onClick={incrementPageHandler}
                            disabled={pageValue.end >= pages ? true : false}
                            className={
                              pageValue.end >= pages
                                ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem] md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-1"
                                : "tw-px-[0.5rem] md:tw-px-[1.05rem] tw-py-[0.25rem] md:tw-py-[0.5rem] tw-text-sm md:tw-text-md tw-rounded-md tw-text-white tw-font-fontHeading tw-font-bold tw-bg-reddishOrange tw-mr-1"
                            }
                          >
                            <KeyboardDoubleArrowRightIcon />
                          </button>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {loading && <Loader />}
                  {!loading && tests?.length === 0 && "No Result Found"}
                </div>
              </div>
            </>
          )}
        </>
      ) : (
        <div>Your are register as Hospital</div>
      )}
    </>
  );
};

export default HospitalTable;
